import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';
import { usuariosApi } from '../../usuario/usuarios/UsuariosService';

export const FAMILIARES_CONST = 'familiares';
export const familiaresApi = `${baseUrl}/${FAMILIARES_CONST}`;

export const allFamiliaresService = async (params) => {
  const res = await axios.get(familiaresApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveFamiliaresService = async (data) => {
  const res = await axios.post(`${usuariosApi}/familiar`, data, {
    headers: token({}),
  });
  return res;
};

export const asignarFamiliaresService = async (data) => {
  const res = await axios.post(`${familiaresApi}/asignar`, data, {
    headers: token({}),
  });
  return res;
};

export const deleteFamiliaresService = async (id) => {
  const res = await axios.delete(`${familiaresApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
